import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("pharmacy.pharmacy");
    },
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("common.patients");
    },
    route: "patients-has-drugs",
    icon: "HomeIcon",
    permission: "get-patient",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("pharmacy.SaleOfPoint");
    },
    route: "sale-of-point",
    icon: "DollarSignIcon",
    permission: "get-patient",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("warehouse.warehouse-dashboard");
    },
    route: "pharmacy-warehouse",
    icon: "ShoppingBagIcon",
    permission: "get-warehouse",
    role: "Pharmacy",
  },

  {
    get title() {
      return i18n.t("common.Categories");
    },
    route: "pharmacy-category",
    icon: "LayersIcon",
    permission: "get-category",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("pharmacy.scientific-drugs-names");
    },
    route: "pharmacy-scientific-drugs-names",
    icon: "LayersIcon",
    permission: "get-category",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("pharmacy.drugs");
    },
    route: "pharmacy-item",
    icon: "ArchiveIcon",
    permission: "get-item",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("warehouse.stockin");
    },
    route: "pharmacy-stockin",
    icon: "LogInIcon",
    permission: "get-stockin",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("pharmacy.dispensed-items");
    },
    route: "pharmacy-stockout",
    icon: "ExternalLinkIcon",
    permission: "get-stockout",
    role: "Pharmacy",
  },
  // {
  //   get title() {
  //     return i18n.t("warehouse.inventory-invoice");
  //   },
  //   route: "pharmacy-inventory-invoice",
  //   icon: "BoxIcon",
  //   permission: "get-inventoryInvoice",
  //   role: "Pharmacy",
  // },
  {
    get title() {
      return i18n.t("warehouse.balance");
    },
    route: "pharmacy-balance",
    icon: "BarChart2Icon",
    permission: "get-balance",
    role: "Pharmacy",
  },
  {
    get title() {
      return i18n.t("pharmacy.drug_store");
    },
    route: "drug-store",
    icon: "PlusCircleIcon",
    permission: "get-balance",
    role: "Pharmacy",
  },
];
